// Two sections load this file (rug-promo-carousel and related-products) and the
// product template uses both, so the browser runs it twice on that page. A
// top-level `class` declaration threw "already been declared" on the second
// run; guarding on the registered element keeps the second run a no-op, the way
// Dawn's own components do it.
if (!customElements.get('rug-promo-carousel-track')) {
  customElements.define(
    'rug-promo-carousel-track',
    class RugPromoCarouselTrack extends HTMLElement {
      constructor() {
        super();
        const track = this.querySelector('.rug-promo-carousel__track');
        const prev = this.querySelector('.rug-promo-carousel__arrow--prev');
        const next = this.querySelector('.rug-promo-carousel__arrow--next');
        if (!track) return;

        if (prev) {
          prev.addEventListener('click', () => {
            const atStart = track.scrollLeft <= 1;
            if (atStart) {
              track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
            } else {
              track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' });
            }
          });
        }
        if (next) {
          next.addEventListener('click', () => {
            const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
            if (atEnd) {
              track.scrollTo({ left: 0, behavior: 'smooth' });
            } else {
              track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' });
            }
          });
        }
      }
    }
  );
}
